import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineDraggabledotsIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M8.5 10a1.9998 1.9998 0 0 0-1.8478 1.2346 2.0002 2.0002 0 0 0 1.4576 2.727A2 2 0 1 0 8.5 10Zm0 7a1.9998 1.9998 0 0 0-1.8478 1.2346 2.0002 2.0002 0 0 0 1.4576 2.727A2 2 0 1 0 8.5 17Zm7-10a1.9998 1.9998 0 0 0 1.9616-2.3902 2.0003 2.0003 0 0 0-2.727-1.4576A1.9998 1.9998 0 0 0 13.5 5a2 2 0 0 0 2 2Zm-7-4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 14a2 2 0 0 0-1.9616 2.3902 2.0004 2.0004 0 0 0 1.5714 1.5714A2 2 0 1 0 15.5 17Zm0-7a2 2 0 0 0-1.9616 2.3902 2.0004 2.0004 0 0 0 1.5714 1.5714A2 2 0 1 0 15.5 10Z"/>
  </SvgIcon>
}

export default LineDraggabledotsIcon
